import React from 'react';
import { Pressable } from 'react-native';
import { X } from 'lucide-react-native';
import { useRouter } from 'expo-router';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../hooks/useTheme';
import { useHaptics } from '../../hooks/useHaptics';

interface SheetCloseButtonProps {
  onClose?: () => void;
  size?: 'default' | 'small';
}

const SIZES = {
  default: { width: 40, height: 40, borderRadius: 40, iconSize: 24 },
  small: { width: 30, height: 30, borderRadius: 15, iconSize: 16 },
} as const;

export function SheetCloseButton({ onClose, size = 'default' }: SheetCloseButtonProps) {
  const router = useRouter();
  const { t } = useTranslation('common');
  const { theme } = useTheme();
  const haptics = useHaptics();

  const s = SIZES[size];

  const handleClose = () => {
    haptics.trigger('light');
    if (onClose) {
      onClose();
    } else {
      router.back();
    }
  };

  return (
    <Pressable
      onPress={handleClose}
      accessibilityRole="button"
      accessibilityLabel={t('actions.close')}
      style={{
        width: s.width,
        height: s.height,
        borderRadius: s.borderRadius,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <X size={s.iconSize} color={theme.text} strokeWidth={2} />
    </Pressable>
  );
}
